import { useCallback, useState } from "react";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useExit() {
  const tError = useErrorTranslation();
  const [isPending, setIsPending] = useState(false);
  const [isCompleted, setIsCompoleted] = useState<null | boolean>(null);
  const [error, setError] = useState("");

  const exit = useCallback(async () => {
    try {
      setIsPending(true);
      const response = await GameMpProvider.exit();
      if (response instanceof RpcMpProviderSuccessResponse) {
        setIsCompoleted(true);
      } else {
        setIsCompoleted(false);
      }
    } catch (e) {
      setIsCompoleted(false);
      setError(tError(e.message));
    } finally {
      setIsPending(false);
    }
  }, []);

  return { exit, isPending, isCompleted, error };
}
